const IStatus = {
  enabled: 'Enabled',
  disabled: 'Disabled',
};

const ILoginType = {
  signIn: 'SignIn',
  signOut: 'SignOut',
  signInWithToken: 'SignInWithToken',
  signInDummy: 'SignInDummy',
  signInStudentApp: 'SignInStudentApp',
  signInDummyStudentApp: 'SignInDummyStudentApp',
  verifyUser: 'VerifyUser',
  verifyUserDummy: 'VerifyUserDummy',
};

const ILoginStatus = {
  passed: 'Passed',
  failed: 'Failed',
};

const IContractStatus = {
  draft: 'Draft',
  approved: 'Approved',
  npl: 'Npl',
  nplReturn: 'NplReturn',
  close: 'Close',
};

const ILoanType = {
  principle: 'Principle',
  interest: 'Interest',
  principleGraduate: 'PrincipleGraduate',
  restructuring: 'Restructuring',
};

const IPaymentRoundType = {
  none: 'None',
  interest: 'Interest',
  principle: 'Principle',
  interestFixed: 'InterestFixed',
};

const ITransactionType = {
  addRestructuring: 'AddRestructuring',
  addLoanDetail: 'AddLoanDetail',
  addFeeDetail: 'AddFeeDetail',
  addPayment: 'AddPayment',
  addDaily: 'AddDaily',
};

const IFeeType = {
  debtCollectionFee: 'DebtCollectionFee',
  debtCollectionFeeCustom: 'DebtCollectionFeeCustom',
  reminderLetter: 'ReminderLetter',
};

const ILoanDetailType = {
  registrationFee: 'RegistrationFee',
  tuitionFee: 'TuitionFee',
  costOfLiving: 'CostOfLiving',
  contractFee: 'ContractFee',
};

const IPaymentType = {
  operator: 'Operator',
  qrCode: 'QRCode',
};

const IEducationStatus = {
  normal: 'Normal',
  suspended: 'Suspended',
  dismiss: 'Dismiss',
  graduated: 'Graduated',
  breachOfPromise: 'BreachOfPromise',
};

const IInterestType = {
  none: 'None',
  principle: 'Principle',
  principleAndInterest: 'PrincipleAndInterest',
  principleInPeriod: 'PrincipleInPeriod',
};

const IMaintenanceSystem = {
  qrPayment: 'QrPayment',
  payment: 'Payment',
};

const IStudentType = {
  onGround: 'OnGround',
  online: 'Online',
};

const IUpdatedType = {
  none: 'None',
  api: 'Api',
  import: 'Import',
  keyIn: 'KeyIn',
};

const IProsecutionStatus = {
  waitingForLawyer: 'WaitingForLawyer',
  attorneySendRequestLetter: 'AttorneySendRequestLetter',
  negotiateWithLawyer: 'NegotiateWithLawyer',
  lawyersFileLawsuit: 'LawyersFileLawsuit',
  judicialCourt: 'JudicialCourt',
  contractNegotiation: 'ContractNegotiation',
  execution: 'Execution',
  auction: 'Auction',
};

const ICreatedWith = {
  telesale: 'Telesale',
  smartApp: 'SmartApp',
  normal: 'Normal',
  online: 'Online',
};

const IGender = {
  male: 'Male',
  female: 'Female',
  other: 'Other',
};

const IFileCategory = {
  loanContract: 'LoanContract',
  suretyContract: 'SuretyContract',
  pdpa: 'Pdpa',
  copyOfIdCard: 'CopyOfIdCard',
  copyOfHouseRegistration: 'CopyOfHouseRegistration',
  imageApproved: 'ImageApproved',
  videoApproved: 'VideoApproved',
  other: 'Other',
};

const IFileFrom = {
  contract: 'Contract',
  borrower: 'Borrower',
  surety: 'Surety',
  prosecution: 'Prosecution',
  other: 'Other',
};

const ISmartAppStatus = {
  draft: 'Draft',
  approved: 'Approved',
  reject: 'Reject',
  inspectioned: 'Inspectioned',
};

const IRestructuringType = {
  judgment: 'Judgment', // remove
  attorneySendRequestLetter: 'AttorneySendRequestLetter', // remove
  afterContractNegotiation: 'AfterContractNegotiation', // remove
  execution: 'Execution', // remove
  normal: 'Normal',
  contractNegotiation: 'ContractNegotiation',
  judicialCourt: 'JudicialCourt',
  oldCondition: 'OldCondition',
  specialCondition: 'SpecialCondition',
};

const IProsecutionResult = {
  win: 'Win',
  lose: 'Lose',
  contractNegotiation: 'ContractNegotiation',
};

const ICaseStatus = {
  draft: 'Draft',
  sendInformationContractToLawyer: 'SendInformationContractToLawyer',
  lawyerAccepted: 'LawyerAccepted',
  lawyerSendInquiryLetter: 'LawyerSendInquiryLetter',
  negotiateWithLawyerForPayment: 'NegotiateWithLawyerForPayment',
  fileLawsuit: 'FileLawsuit',
  courtJudgment: 'CourtJudgment',
  makeDebtRestructuringContract: 'MakeDebtRestructuringContract',
  sendEnforcementOrder: 'SendEnforcementOrder',
  submitForLegalExecution: 'SubmitForLegalExecution',
  issueWarrantForEnforcementOfficer: 'IssueWarrantForEnforcementOfficer',
  submitEnforcementCaseDocument: 'SubmitEnforcementCaseDocument',
  announcePublicAuction: 'AnnouncePublicAuction',
  holdCase: 'HoldCase',
  cancelCase: 'CancelCase',
  closeCase: 'CloseCase',
};

const IContractSummarizeStatus = {
  draft: 'Draft',
  normal: 'Normal',
  aging: 'Aging',
  prosecution: 'Prosecution',
  nplReturn: 'NplReturn',
  close: 'Close',
};

const IUserStatus = {
  active: 'Active',
  inactive: 'Inactive',
  locked: 'Locked',
};

const INotificationType = {
  payment: 'Payment',
  loanTransfer: 'LoanTransfer',
  outstandingBalanceReminder: 'OutstandingBalanceReminder',
  sms: 'Sms',
  paymentExpense: 'PaymentExpense',
  custom: 'Custom',
};

const IDebtCollectionFeeType = {
  none: 'None',
  fixed: 'Fixed',
  custom: 'Custom',
};

const IExpenseType = {
  contractFee: 'ContractFee',
  taxAmount: 'TaxAmount',
  processingFee: 'ProcessingFee',
  courtOrderExpense: 'CourtOrderExpense',
};

const IApprovedStatus = {
  draft: 'Draft',
  approved: 'Approved',
  cancel: 'Cancel',
};

const IProsecutionType = {
  prosecuteCase: 'ProsecuteCase',
  enforceCase: 'EnforceCase',
};

const iCalculationMethod = {
  deleteTransactions: 'DeleteTransactions',
  deleteTransactionsByContractIdAndTransactionDate: 'DeleteTransactionsByContractIdAndTransactionDate',
  reGenerateTransactions: 'ReGenerateTransactions',
  migration: 'Migration',
};

const iCalculationType = {
  internal: 'Internal',
  dailyCalculators: 'DailyCalculators',
  monthlyAddFeeDetails: 'MonthlyAddFeeDetails',
  updateContractStatus: 'UpdateContractStatus',
  createPayment: 'CreatePayment',
  apiBblNotifySuccess: 'ApiBblNotifySuccess',
  migrateAgingToTransaction: 'MigrateAgingToTransaction',
};

// Custom Interface
const INotiQueryType = {
  object: 'Object',
  schemas: 'Schemas',
};

const INotiActionType = {
  loanDetailPlan: 'LoanDetailPlan',
  loanDetailPlanWhenClose: 'LoanDetailPlanWhenClose',
  principleBalanceIsZero: 'PrincipleBalanceIsZero',
  educationStatusBreachOfPromise: 'EducationStatusBreachOfPromise',
  curriculumExternalsNotMapping: 'CurriculumExternalsNotMapping',
  externalBorrowerUnApproved: 'ExternalBorrowerUnApproved',
  isRuledButNotRestructuring: 'IsRuledButNotRestructuring',
  isRestructuringAgingMoreThan90Days: 'IsRestructuringAgingMoreThan90Days',
  isDraft: 'IsDraft',
};

const INotiCallActionType = {
  ntfAll: 'NtfAll',
  ntfStage1: 'NtfStage1',
  ntfStage2: 'NtfStage2',
  ntfStage3: 'NtfStage3',
};

const INotiCallExActionType = {
  ntfAll: 'NtfAll',
  inProsecution: 'InProsecution',
  assignedByUser: 'AssignedByUser',
  unassigned: 'Unassigned',
};

const INotiPaymentScheduleActionType = {
  ntfAll: 'NtfAll',
  overdue: 'Overdue',
  dueToday: 'DueToday',
  upcoming: 'Upcoming',
};

const INotiSaleActionType = {
  all: 'All',
  inProcess: 'InProcess',
  waitingInspectioned: 'WaitingInspectioned',
  reject: 'Reject',
  waitingPayment: 'WaitingPayment',
  success: 'Success',
};

const INotiLawyerActionType = {
  waitingLegalAcceptCase: 'WaitingLegalAcceptCase',
  waitingLegalAcceptCaseExecution: 'WaitingLegalAcceptCaseExecution',
  timeIsUpHoldCase: 'TimeIsUpHoldCase',
};

const IOrderBy = {
  asc: 'asc',
  desc: 'desc',
};

const IDateDbType = {
  normal: 'normal',
  startOfMonth: 'startOfMonth',
  endOfMonth: 'endOfMonth',
  startOfDate: 'startOfDate',
  endOfDate: 'endOfDate',
};

const ITaskType = {
  // Example Task
  example: 'example',
  // Daily Task
  dailyCalculators: 'dailyCalculators',
  dailyCreateUserStudent: 'dailyCreateUserStudent',
  dailyChangeEducationStatus: 'dailyChangeEducationStatus',
  dailyUpdateCurriculumExternalApi: 'dailyUpdateCurriculumExternalApi',
  getContractTransactionNotUpdate: 'getContractTransactionNotUpdate',
  dailyCallHistoriesUnReceivedAll: 'dailyCallHistoriesUnReceivedAll',
  // Monthly Task
  getContractToBeFee: 'getContractToBeFee',
  getContractNextRoundNull: 'getContractNextRoundNull',
  getContractNextRoundFirstPrinciplePeriod: 'getContractNextRoundFirstPrinciplePeriod',
  monthlyAddFeeDetails: 'monthlyAddFeeDetails',
  // Noti Task
  outstandingBalanceReminderBefore5: 'outstandingBalanceReminderBefore5',
  outstandingBalanceReminderDay5: 'outstandingBalanceReminderDay5',
  outstandingBalanceReminderDay15: 'outstandingBalanceReminderDay15',
  outstandingBalanceReminderDay30: 'outstandingBalanceReminderDay30',
  outstandingBalanceReminderDay60: 'outstandingBalanceReminderDay60',
};

const IAppType = {
  adminWeb: 'admin-web',
  studentWeb: 'student-web',
  smartApp: 'smart-app',
  executiveApp: 'executive-app',
  studentApp: 'student-app',
};

const IStageAging = {
  normal: 'normal',
  stage1: 'stage1',
  stage2: 'stage2',
  stage3: 'stage3',
};

const IPaymentAmountDetailType = {
  contractFee: 'contractFee', // ค่าธรรมเนียมการทำสัญญา
  taxAmount: 'taxAmount', // ค่าอากรแสตมป์
  processingFee: 'processingFee', // ค่าดำเนินการ
  courtOrderExpense: 'courtOrderExpense', // ค่าใช้จ่ายอื่นตามคำสั่งศาล
  outstanding: 'outstanding', // ยอดค้างชำระ
  normal: 'normal', // ยอดที่ต้องชำระปกติ
  close: 'close', // ยอดชำระปิดบัญชี
  custom: 'custom', // ยอดชำระกำหนดเอง
};

const IQrPaymentType = {
  extra: 'extra', // t0
  normal: 'normal', // t1
  custom: 'custom', // t2
  close: 'close', // t3
  outstanding: 'outstanding', // t4
  contractFee: 'contractFee', // t5
  registrationFeeExtra: 'registrationFeeExtra', // t6
  taxAmount: 'taxAmount', // t7
  processingFee: 'processingFee', // t8
  courtOrderExpense: 'courtOrderExpense', // t9
};

const IQrPaymentTypeCode = {
  t0: 'T0', // extra
  t1: 'T1', // normal
  t2: 'T2', // custom
  t3: 'T3', // close
  t4: 'T4', // outstanding
  t5: 'T5', // contractFee
  t6: 'T6', // registrationFeeExtra
  t7: 'T7', // taxAmount
  t8: 'T8', // processingFee
  t9: 'T9', // courtOrderExpense
};

const IComparisonOperator = {
  le: 'le',
  lte: 'lte',
  ge: 'ge',
  gte: 'gte',
};

const ISignerType = {
  signerContract: 'SignerContract',
  debtCollection: 'DebtCollection',
  lawyer: 'Lawyer',
};

const IEnv = {
  development: 'development',
  production: 'production',
};

const IOtpType = {
  approvedRestructuring: 'ApprovedRestructuring',
};

// Value Interface

const INull = 'Null';

const IMaster = 'master';

module.exports = {
  IStatus,
  ILoginType,
  ILoginStatus,
  IContractStatus,
  ILoanType,
  IPaymentRoundType,
  ITransactionType,
  IFeeType,
  ILoanDetailType,
  IPaymentType,
  IEducationStatus,
  IInterestType,
  IMaintenanceSystem,
  IStudentType,
  IUpdatedType,
  IProsecutionStatus,
  ICreatedWith,
  IGender,
  IFileCategory,
  IFileFrom,
  ISmartAppStatus,
  IRestructuringType,
  IProsecutionResult,
  ICaseStatus,
  IContractSummarizeStatus,
  IUserStatus,
  INotificationType,
  IDebtCollectionFeeType,
  IExpenseType,
  IApprovedStatus,
  IProsecutionType,
  iCalculationMethod,
  iCalculationType,
  // custom
  INotiQueryType,
  INotiActionType,
  INotiCallActionType,
  INotiCallExActionType,
  INotiPaymentScheduleActionType,
  INotiSaleActionType,
  INotiLawyerActionType,
  IDateDbType,
  IOrderBy,
  ITaskType,
  IAppType,
  IStageAging,
  IPaymentAmountDetailType,
  IQrPaymentType,
  IQrPaymentTypeCode,
  IComparisonOperator,
  ISignerType,
  IEnv,
  IOtpType,
  // Value Interface
  INull,
  IMaster,
};
